import * as React from "react";
import {Display} from "./panels/display/display";
import {YAxis} from "./panels/y-axis/y-axis";
import {DataLabels} from "./panels/data-labels/data-labels";
import {Colors} from "./panels/colors/colors";
import {TileTitle} from "../common/tile-title/tile-title";
import {XAxes} from "./panels/x-axis/x-axes";
import {Legend} from "./panels/legend/legend";
import {OtherOptions} from "../common/other-options/other-options";
import {ReferenceLines} from "../common/reference-lines/reference-lines";

export const HorizontalBar = ({tile, form, size, parentTile, colorsTileConfig, referenceLinesPanel, tileAction, isContainerTile}) =>
    [Display, TileTitle, (props) => ReferenceLines({...props, referenceLinesPanel}), ...XAxes(tile.value.style.xAxis), YAxis, DataLabels, Colors, Legend, OtherOptions]
        .map((panel) =>
            panel({
                tile,
                form,
                size,
                parentTile,
                colorsTileConfig,
                tileAction,
                isContainerTile,
            })
        )
        .filter((v) => v);
